exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-shift {\n  height: 20px;\n  width: 150px;\n  line-height: 1;\n  padding: 0;\n  margin: 2px;\n  border: 1px solid black; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/sbutton/sbutton.component.scss
// module id = 421
// module chunks = 1